import React, { Component } from "react";
import "./smartCharts.css";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import _ from "lodash";
import moment from "moment";
import LoadingOverlay from "react-loading-overlay";
import "./smartCharts.css";

import Loader from "../common/components/Loader";
import CreateSmartChart from "./components/CreateSmartChart";
import { recommendationsTableData, smartChartTableData } from "../../config/tableData";
import actions from "./actions";
import "../../assets/css/smart-chart.css";
import SmartChartMain from "./components/smartChartMain";
import ConfirmationModal from "../common/components/ConfirmationModal";
import Portal from "../common/components/Portal";
import {
    checkPermission,
    addToBreadCrumpData,
    resetBreadCrumpData,
    bulkResetBreadCrumpData,
    popBreadCrumpData,
    showAlert as showAlertUtil
} from "../../config/utils";
import { permissions } from "../../config/permissions";
import { resolveDefaultClientFromList } from "../../utils/dashboardSession";
import SmartChartDataEditForm from "./components/SmartChartDataEditForm";
import ViewPropertyModal from "./components/ViewPropertyModal";
import ReportsByTemplateModal from "./components/ReportsByTemplateModal";
import LockPasswordModal from "./components/LockPasswordModal";
import SelectDownloadTypeModal from "../common/components/SelectExportTypeWordModal";
import AssignUserToFavoriteModal from "./components/AssignUserToFavoriteModal";
import CreateReportFromCoreReportsModal from "./components/CreateReportFromCoreReportsModal";
import { downloadPresignedUrlFile } from "../common/actions";
import qs from "query-string";

class Index extends Component {
    constructor(props) {
        super(props);
        const {
            match: {
                params: { section }
            }
        } = this.props;
        this.state = {
            isLoading: false,
            paginationParams:
                !this.props.isModalView && !this.props.isFavoriteView
                    ? this.props.smartChartReducer.entityParams.paginationParams
                    : {
                          totalPages: 0,
                          perPage: 100,
                          currentPage: 0,
                          totalCount: 0
                      },
            showFormModal: false,
            showWildCardFilter: false,
            selectedRowId: this.props.smartChartReducer.entityParams.selectedRowId,
            params:
                !this.props.isModalView && !this.props.isFavoriteView
                    ? this.props.smartChartReducer.entityParams.params
                    : {
                          limit: 100,
                          offset: 0,
                          search: "",
                          filters: null,
                          list: null,
                          active: true
                      },
            tableData: {
                keys: smartChartTableData.keys,
                config: this.props.smartChartReducer.entityParams.tableConfig || _.cloneDeep(smartChartTableData.config)
            },
            RecommendationTableData: {
                keys: _.cloneDeep(recommendationsTableData.keys),
                config: this.props.recommendationsReducer.entityParams[section]?.tableConfig || _.cloneDeep(recommendationsTableData.config)
            },
            alertMessage: "",
            wildCardFilterParams: this.props.smartChartReducer.entityParams.wildCardFilterParams,
            filterParams: this.props.smartChartReducer.entityParams.filterParams,
            showConfirmModal: false,
            selectedSmartChartReport: "",
            showSmartChartDataEditModal: this.props.openDashboardExportOnMount || false,
            selectedSmartChartData: null,
            mFilters: { exportby_user_ids: this.props.smartChartReducer?.entityParams?.exportby_user_ids || [] } || {},
            defaultFilterParams: {},
            selectedProperty: null,
            showViewPropertyModal: false,
            showViewReportsModal: false,
            showLockTemplateModal: false,
            selectedReportTemplate: null,
            isLockLoading: false,
            actionTypeForModal: "",
            showSelectDownloadTypeModal: false,
            selectedReport: "",
            sortParams:
                !this.props.isModalView && !this.props.isFavoriteView
                    ? this.props.smartChartReducer.entityParams?.sortParams
                    : { sort_by: "created_date", order: "desc" },
            filterKey:
                !this.props.isModalView && !this.props.isFavoriteView
                    ? this.props.smartChartReducer.entityParams?.filterKey
                    : this.props.isFavoriteView
                      ? "yes"
                      : "",
            showAssignUsersToFavoritesModal: false,
            showCreateReportFromCoreReportModal: false,
            isSkeletonView: false,
            isViewReportModal: false,
            selectedTabForFavoriteView:
                this.props.openDashboardExportOnMount
                    ? "reporttemplates"
                    : this.props.initialTab || (checkPermission("forms", permissions.CORE_REPORT, "view") ? "corereports" : "reporttemplates"),
            setUpdateCoreReport: false,
            showDashboardSmartChartExport: this.props.openDashboardExportOnMount || false,
            isReportViewModal: false
        };
    }

    componentDidMount = async () => {
        const { isModalView = false, isFavoriteView = false } = this.props;
        const shouldApplyDefaultClientFilter = !isModalView || (isFavoriteView && this.state.selectedTabForFavoriteView !== "reports");
        let currentSection =
            this.props.isFavoriteView || this.props?.isReportView ? this.state.selectedTabForFavoriteView : this.props?.match?.params?.section;
        if (shouldApplyDefaultClientFilter) {
            let currentUser = localStorage.getItem("userId") || "";
            await this.props.getSmartChartMasterFilterDropDown("clients", "smart_report_list_filter", {
                user_id: currentUser,
                source: currentSection
            });
            let clientList = this.props.smartChartReducer.masterFilterList?.smart_report_list_filter?.clients || [];
            if (clientList.length) {
                let defaultClient = resolveDefaultClientFromList(clientList);
                if (defaultClient?.id) {
                    await this.props.getSmartChartMasterFilterDropDown("projects", "smart_report_list_filter", {
                        client_id: defaultClient.id,
                        user_id: currentUser,
                        source: currentSection
                    });
                    let projectList = this.props.smartChartReducer.masterFilterList?.smart_report_list_filter?.projects || [];
                    let defaultProject = projectList.find(project => project.default == true) || null;
                    await this.setState({
                        mFilters: {
                            client_ids: [defaultClient?.id],
                            project_ids: defaultProject ? [defaultProject?.id] : []
                        },
                        defaultFilterParams: {
                            client_ids: [defaultClient?.id],
                            project_ids: defaultProject ? [defaultProject?.id] : []
                        }
                    });
                    await this.updateEntityParams();
                }
            }
        }

        await this.refreshExportedSmartChartList();
    };

    componentDidUpdate = async prevProps => {
        if (!prevProps.openDashboardExportOnMount && this.props.openDashboardExportOnMount) {
            this.setState({
                showDashboardSmartChartExport: true,
                showSmartChartDataEditModal: true
            });
        }
        if (prevProps.match.params.section !== this.props.match.params.section && this.props.match.params.section === "reports") {
            await this.refreshExportedSmartChartList();
        }
    };

    componentWillUnmount = async () => {
        await this.props.resetSmartReportTemplateEntityParams();
    };

    setUpdateState = async => {
        this.setState({
            setUpdateCoreReport: false
        });
    };

    refreshExportedSmartChartList = async (exportProgressCheck = true) => {
        const { isModalView = false, isFavoriteView = false } = this.props;
        let currentUser = localStorage.getItem("userId") || "";
        this.setState({ isLoading: exportProgressCheck });
        const { params, paginationParams, tableData, mFilters, sortParams, filterKey } = this.state;
        let exportedSmartChartList = [];
        let totalCount = 0;
        const { filterKeys, limit, offset, search, template_filter, date_filter } = params;
        const { sort_by, order } = sortParams;
        const snapshotBefore = {
            client_ids: JSON.stringify(this.state?.mFilters?.client_ids || []),
            project_ids: JSON.stringify(this.state?.mFilters?.project_ids || []),
            user_id: JSON.stringify(this.state?.mFilters?.exportby_user_ids || [])
        };
        let templateParams = {
            ...filterKeys,
            limit,
            offset,
            search_query: search,
            sort_by,
            order,
            date_filter
            // ordering,
            // per_page_count: limit,
            // page_number: offset + 1
        };
        if (mFilters?.project_ids?.length) {
            templateParams.project_id = [...mFilters.project_ids];
        }
        if (mFilters?.client_ids?.length) {
            templateParams.client_id = mFilters?.client_ids[0];
        }
        if (mFilters?.exportby_user_ids?.length) {
            templateParams.exportby_user_ids = mFilters?.exportby_user_ids;
        }
        if (filterKey) {
            templateParams.favourite = filterKey;
        }
        if (this.props?.isGeoHierarchyReports) {
            templateParams.client_id = this.props?.geoHierarchyClientId;
            templateParams[this.props?.entityType ? `${this.props?.entityType}` : "building_id"] = this.props?.entityId;
        }
        // if (!mFilters?.project_ids?.length && !mFilters?.client_ids?.length) {
        //     templateParams.user_id = currentUser;
        // }
        templateParams.user_id = currentUser;
        if (!isModalView) {
            await this.props.getExportedSmartChartList(templateParams);
        } else if (isFavoriteView) {
            if (filterKey) {
                templateParams.favourite = filterKey;
            }
            await this.props.getExportedSmartChartList({ ...templateParams });
        } else {
            const { isSkeletonView = false } = this.props;
            let reportByTemplateParams = {
                property_id: this.props.currentPropertyId,
                user_id: currentUser,
                sort_by,
                order,
                search_query: search
            };
            if (filterKey) {
                reportByTemplateParams.favourite = filterKey;
            }
            if (isSkeletonView) {
                reportByTemplateParams.property_id = null;
                reportByTemplateParams.mapped_to_skeleton_id = this.props.currentPropertyId;
            }
            await this.props.getReportsByTemplateList({ ...reportByTemplateParams });
        }
        // If any filter changed during the await, this response is stale → discard it
        // The newer filter-change call will update the UI with correct data
        const snapshotAfter = {
            client_ids: JSON.stringify(this.state?.mFilters?.client_ids || []),
            project_ids: JSON.stringify(this.state?.mFilters?.project_ids || []),
            user_id: JSON.stringify(this.state?.mFilters?.exportby_user_ids || [])
        };
        const filtersChanged =
            snapshotBefore.client_ids !== snapshotAfter.client_ids ||
            snapshotBefore.project_ids !== snapshotAfter.project_ids ||
            snapshotBefore.user_id !== snapshotAfter.user_id;

        if (filtersChanged && (this.props.match.params.section === "reports" || this.state.selectedTabForFavoriteView === "reports")) {
            return false;
        }
        const { exportedSmartChartListResponse, reportsByTemplateListResponse } = this.props.smartChartReducer;
        exportedSmartChartList = !isModalView || isFavoriteView ? exportedSmartChartListResponse?.data : reportsByTemplateListResponse?.data || [];
        totalCount = !isModalView || isFavoriteView ? exportedSmartChartListResponse?.count : reportsByTemplateListResponse?.count || 0;

        // go to previous page if no data found in the current page
        if (exportedSmartChartList && !exportedSmartChartList.length && paginationParams.currentPage) {
            await this.setState({
                paginationParams: {
                    ...paginationParams,
                    currentPage: this.state.paginationParams.currentPage - 1
                },
                params: {
                    ...params,
                    offset: (paginationParams.currentPage - 1) * paginationParams.perPage
                }
            });
            return await this.refreshExportedSmartChartList();
        }

        if (
            (exportedSmartChartList && !exportedSmartChartList.length && exportedSmartChartListResponse && exportedSmartChartListResponse.error) ||
            exportedSmartChartListResponse.error ||
            exportedSmartChartListResponse.detail
        ) {
            this.showAlert(
                typeof exportedSmartChartListResponse.detail === "string"
                    ? exportedSmartChartListResponse.detail
                    : (exportedSmartChartListResponse.error ?? "")
            );
        }

        exportedSmartChartList?.map(temp => {
            temp.created_at = moment(temp.created_date).format("MM-DD-YYYY h:mm A");
        });
        this.setState({
            tableData: {
                ...tableData,
                data: exportedSmartChartList
                // config: tableData.config
            },
            exportedSmartChartList,
            paginationParams: {
                ...paginationParams,
                totalCount: totalCount,
                totalPages: Math.ceil(totalCount / paginationParams.perPage)
            },
            isLoading: false
        });
        return true;
    };

    showAlert = msg => showAlertUtil(msg);

    updateWildCardFilter = async newFilter => {
        const { params, paginationParams } = this.state;
        await this.setState({
            params: {
                ...params,
                offset: 0,
                filters: newFilter
            },
            paginationParams: {
                ...paginationParams,
                currentPage: 0
            }
        });
        // this.updateEntityParams();
        await this.refreshExportedSmartChartList();
    };

    updateEntityParams = async () => {
        const { mFilters, filterKey, sortParams, params, paginationParams } = this.state;
        const { isModalView = false, isFavoriteView = false } = this.props;
        if (!isModalView && !isFavoriteView) {
            await this.props.updateSmartReportsEntityParams({
                mFilters: { ...mFilters },
                entityParams: { filterKey, sortParams, params, paginationParams, exportby_user_ids: mFilters?.exportby_user_ids || [] }
            });
        }
    };

    resetAllFilters = async () => {
        const { defaultFilterParams } = this.state;
        await this.setState({
            mFilters: {
                ...defaultFilterParams
            },
            filterKey: "",
            sortParams: {
                sort_by: "created_date",
                order: "desc"
            },
            params: {
                limit: 100,
                offset: 0,
                search: "",
                filters: null,
                list: null,
                active: true
            }
        });
        this.updateEntityParams();
        await this.refreshExportedSmartChartList();
    };
    resetAll = async () => {
        await this.setState({
            selectedRegion: null,
            paginationParams: {
                totalPages: 0,
                perPage: 100,
                currentPage: 0,
                totalCount: 0
            },
            params: {
                ...this.state.params,
                limit: 100,
                offset: 0,
                search: "",
                project_id: null,
                filters: null,

                order: null,
                list: null
            },
            tableData: {
                ...this.state.tableData,
                config: _.cloneDeep(smartChartTableData.config)
            },
            wildCardFilterParams: {},
            filterParams: {},
            selectedRowId: null,
            filterKey: "",
            sortParams: {
                sort_by: "created_date",
                order: "desc"
            }
        });
        this.updateEntityParams();
        await this.refreshExportedSmartChartList();
    };

    resetSort = async () => {
        await this.setState({
            params: {
                ...this.state.params,
                order: null
            }
        });
        // this.updateEntityParams();
        await this.refreshExportedSmartChartList();
    };
    isColunmVisibleChanged = () => {
        let flag = false;
        const {
            tableData: { keys, config }
        } = this.state;
        keys.map(key => {
            if (!_.isEqual(config[key]?.isVisible, smartChartTableData.config[key]?.isVisible)) {
                flag = true;
            }
        });
        return flag;
    };
    getListForCommonFilter = async params => {
        // await this.props.getListForCommonFilter(params);
        // return (
        //     (this.props.reportPropertyReducer.getListForCommonFilterResponse &&
        //         this.props.reportPropertyReducer.getListForCommonFilterResponse.list) ||
        //     []
        // );
    };

    updateCommonFilter = async commonFilters => {
        await this.setState({
            params: {
                ...this.state.params,
                offset: 0,
                list: commonFilters
            },
            paginationParams: {
                ...this.state.paginationParams,
                currentPage: 0
            }
        });
        // this.updateEntityParams();
        await this.refreshExportedSmartChartList();
    };

    updateTableSortFilters = async searchKey => {
        if (this.state.params.order) {
            await this.setState({
                params: {
                    ...this.state.params,
                    order: {
                        ...this.state.params.order,
                        [searchKey]: this.state.params.order[searchKey] === "desc" ? "asc" : "desc"
                    }
                }
            });
        } else {
            await this.setState({
                params: {
                    ...this.state.params,
                    order: { [searchKey]: "asc" }
                }
            });
        }
        // this.updateEntityParams();
        await this.refreshExportedSmartChartList();
    };

    handleHideColumn = async keyItem => {
        if (keyItem !== "selectAll" && keyItem !== "deselectAll") {
            await this.setState({
                tableData: {
                    ...this.state.tableData,
                    config: {
                        ...this.state.tableData.config,
                        [keyItem]: {
                            ...this.state.tableData.config[keyItem],
                            isVisible: !this.state.tableData.config[keyItem].isVisible
                        }
                    }
                }
            });
        } else {
            let tempConfig = this.state.tableData.config;
            this.state.tableData.keys.map(item => {
                if (keyItem === "selectAll") {
                    tempConfig[item].isVisible = true;
                } else {
                    tempConfig[item].isVisible = false;
                }
            });
            await this.setState({
                tableData: {
                    ...this.state.tableData,
                    config: tempConfig
                }
            });
        }
        // await this.updateEntityParams();
        return true;
    };

    updateSelectedRow = async rowId => {
        await this.setState({
            selectedRowId: rowId
        });
        // await this.updateEntityParams();
    };

    handlePerPageChange = async e => {
        const { paginationParams, params } = this.state;
        await this.setState({
            paginationParams: {
                ...paginationParams,
                perPage: e.target.value,
                currentPage: 0
            },
            params: {
                ...params,
                offset: 0,
                limit: e.target.value
            }
        });
        await this.refreshExportedSmartChartList();
    };

    handlePageClick = async page => {
        const { paginationParams, params } = this.state;
        await this.setState({
            paginationParams: {
                ...paginationParams,
                currentPage: page.selected
            },
            params: {
                ...params,
                // offset: page.selected * paginationParams.perPage
                offset: page.selected
            }
        });
        await this.refreshExportedSmartChartList();
    };

    toggleWildCardFilter = () => {
        const { showWildCardFilter } = this.state;
        this.setState({
            showWildCardFilter: !showWildCardFilter
        });
    };

    handleGlobalSearch = async search => {
        const { params } = this.state;
        await this.setState({
            params: {
                ...params,
                offset: 0,
                search
            },
            paginationParams: {
                ...this.state.paginationParams,
                currentPage: 0
            }
        });
        this.updateEntityParams();
        await this.refreshExportedSmartChartList();
    };

    showLongAlert = msg => showAlertUtil(msg, true);

    handleDownloadItem = async url => {
        downloadPresignedUrlFile(url);
    };

    deleteSmartChartReport = id => {
        this.setState({
            showConfirmModal: true,
            selectedSmartChartReport: id
        });
    };

    renderConfirmationModal = () => {
        const { showConfirmModal } = this.state;
        if (!showConfirmModal) return null;
        return (
            <Portal
                body={
                    <ConfirmationModal
                        heading={"Do you want to delete this smart report?"}
                        message={"This action cannot be reverted, are you sure that you need to delete this item?"}
                        onNo={() => this.setState({ showConfirmModal: false })}
                        onYes={this.deleteSmartChartReportConfirm}
                    />
                }
                onCancel={() => this.setState({ showConfirmModal: false })}
            />
        );
    };

    deleteSmartChartReportConfirm = async () => {
        const { selectedSmartChartReport } = this.state;
        this.setState({
            isLoading: true,
            showConfirmModal: false
        });
        await this.props.deleteSmartChartReport(selectedSmartChartReport);
        if (
            this.props.smartChartReducer.deleteSmartChartReportResponse?.error ||
            this.props.smartChartReducer.deleteSmartChartReportResponse?.detail
        ) {
            this.showAlert(this.props.smartChartReducer.deleteSmartChartReportResponse?.detail || "Oops..! failed to delete");
        } else {
            this.showAlert("Deleted successfully");
            await this.refreshExportedSmartChartList();
        }
        this.setState({
            showConfirmModal: false,
            selectedSmartChartReport: null,
            isLoading: false
        });
    };

    regenerateSmartChart = async params => {
        const {
            exportSmartChartData,
            isFavoriteView = false,
            match: {
                params: { section = "" }
            },
            location: { pathname, search }
        } = this.props;
        let currentUser = localStorage.getItem("userId") || "";
        await exportSmartChartData({ ...params, user_id: currentUser });
        await this.setState({ showViewPropertyModal: false, selectedProperty: null });
        if (pathname?.toLowerCase() === "/dashboard" && this.state.selectedTabForFavoriteView === "reporttemplates") {
            this.setState({ selectedTabForFavoriteView: "reports" });
        } else if (section === "reports" || isFavoriteView || this.props?.isGeoHierarchyReports) {
            this.refreshExportedSmartChartList();
        } else {
            this.props.history.push("/smartcharts/reports");
        }
        if (this.props?.smartChartReducer?.exportSmartChartDataResponse?.success === false) {
            this.showLongAlert(
                this.props?.smartChartReducer?.exportSmartChartDataResponse?.error ??
                    this.props?.smartChartReducer?.exportSmartChartDataResponse?.detail
            );
        } else {
            this.showLongAlert(
                "Report generation initiated and will be ready for download shortly. Please click the Refresh button to check for status."
            );
        }
    };

    toggleSmartChartDataEditModal = (data, type) => {
        this.setState({
            showSmartChartDataEditModal: !this.state.showSmartChartDataEditModal,
            showDashboardSmartChartExport: false,
            selectedSmartChartData: data,
            actionTypeForModal: type
        });
    };
    getClientsData = data => {
        const clientObj = data?.find(item => item.name === "Clients");
        return clientObj ? { name: clientObj.value[0] } : {};
    };
    renderSmartChartDataEditModal = () => {
        const { showSmartChartDataEditModal, selectedSmartChartData, actionTypeForModal, showDashboardSmartChartExport } = this.state;
        if (!showSmartChartDataEditModal) return null;
        return (
            <Portal
                body={
                    <SmartChartDataEditForm
                        onCancel={() => this.toggleSmartChartDataEditModal()}
                        selectedData={
                            !showDashboardSmartChartExport ? selectedSmartChartData : this.getClientsData(this.props.dashboardReducer?.filterContents)
                        }
                        updateData={!showDashboardSmartChartExport ? this.updateSmartReportData : this.props.handleExportSmartReports}
                        heading={`${showDashboardSmartChartExport ? "" : actionTypeForModal || "Update"} ${
                            selectedSmartChartData?.property_type === "CLI_SKEL" || selectedSmartChartData?.property_type === "SKEL"
                                ? "Core Report"
                                : "Smart Chart Report"
                        }`}
                        regenerateSmartChart={this.regenerateSmartChart}
                        exportSmartChart={async (exportParams, isExport) => {
                            if (!showDashboardSmartChartExport) {
                                this.handleExportSmartReport(exportParams);
                            } else {
                                await this.props.handleExportSmartReports(exportParams, isExport);
                                await this.changeTabsInFavModal(isExport ? "reports" : "reporttemplates");
                            }
                        }}
                        buttonText={!showDashboardSmartChartExport ? actionTypeForModal || "Update" : "Save as Template"}
                        hasExportType={
                            actionTypeForModal === "Regenerate" || actionTypeForModal === "Export" || showDashboardSmartChartExport ? true : false
                        }
                        actionType={showDashboardSmartChartExport ? "DashboardExport" : actionTypeForModal}
                        isFavoriteView={this.props?.isFavoriteView}
                        smartChartPropertyByIdData={this.props.smartChartReducer?.getSmartChartPropertyByIdResponse}
                        actionTypeForModal={showDashboardSmartChartExport ? "DashboardExport" : actionTypeForModal}
                        btnText={showDashboardSmartChartExport ? "Save & Export" : false}
                        hasNoConfirmationModal={true}
                    />
                }
                onCancel={() => this.toggleSmartChartDataEditModal()}
                zIndex={10000}
            />
        );
    };

    updateSmartReportData = async (params, id, properties_text) => {
        if (this.state.selectedSmartChartData?.property_type === "CLI_SKEL" || properties_text) {
            await this.props.updateCoreReport(id, { name: params?.name, notes: params?.notes, properties_text });
            const { updateCoreReportDataResponse } = this.props.smartChartReducer;
            if (updateCoreReportDataResponse?.success) {
                this.setState({
                    setUpdateCoreReport: true
                });
                this.showAlert("Updated successfully");
            } else if (updateCoreReportDataResponse?.detail || updateCoreReportDataResponse?.error) {
                this.showAlert(updateCoreReportDataResponse?.detail || updateCoreReportDataResponse?.error);
            }
        } else {
            await this.props.updateSmartReportData(id, params);
            await this.refreshExportedSmartChartList();
            const { updateSmartChartDataResponse } = this.props.smartChartReducer;
            if (this.props.smartChartReducer.updateSmartChartDataResponse?.success) {
                this.showAlert("Updated successfully");
            } else if (updateSmartChartDataResponse?.detail || updateSmartChartDataResponse?.error) {
                this.showAlert(updateSmartChartDataResponse?.detail || updateSmartChartDataResponse?.error);
            }
        }
    };

    updateMfilterForSmartChartList = async params => {
        try {
            let currentUser = localStorage.getItem("userId") || "";
            let updateFilterParams = {};
            let currentSection =
                this.props?.isFavoriteView || this.props?.isReportView ? this.state.selectedTabForFavoriteView : this.props?.match?.params?.section;
            if (params.mfilterKey === "client_ids") {
                await this.props.getSmartChartMasterFilterDropDown("projects", "smart_report_list_filter", {
                    client_id: params.filterValues?.[0],
                    exportby_user_ids: [],
                    user_id: currentUser,
                    source: currentSection
                });
                updateFilterParams = {
                    [params.mfilterKey]: params.filterValues,
                    project_ids: [],
                    exportby_user_ids: []
                };
                await this.props.updateSmartReportTemplateEntityParams({
                    entityParams: {
                        ...this.props.smartChartReducer.propertyEntityParams,
                        exportby_user_ids: []
                    }
                });
            } else {
                updateFilterParams = { [params.mfilterKey]: params.filterValues };
            }
            this.setState(
                {
                    mFilters: {
                        ...this.state.mFilters,
                        ...updateFilterParams
                    },
                    tableData: {
                        ...this.state.tableData,
                        data: []
                    }
                },
                () => {
                    this.updateEntityParams();
                    this.refreshExportedSmartChartList();
                }
            );
        } catch (error) {
            console.error("updateMfilterForSmartChartList failed:", error);
        }
    };
    handleClickTab = (tab, favView = false) => {
        if (favView) {
            this.setState({ selectedTabForFavoriteView: tab.key });
        } else {
            if (
                tab.key === "reporttemplates" ||
                tab.key === "reports" ||
                tab.key === "documents" ||
                tab.key === "images" ||
                tab.key === "corereports" ||
                tab.key === "taskmanager"
            ) {
                this.props.history.push(tab.url);
                bulkResetBreadCrumpData([
                    { key: "main", name: "Smart Reports & Charts", path: `/smartcharts/${tab.key}` },
                    {
                        key: tab.key,
                        name: tab.label,
                        path: `/smartcharts/${tab.key}`
                    }
                ]);
            }
        }
    };

    viewSmartChartProperty = async propertyId => {
        this.setState({ showViewPropertyModal: true, selectedProperty: propertyId });
    };

    exportSmartChartFromView = async id => {
        //temp fxn,will remove in future
        await this.props.exportSmartChartData({ property_id: id });
        this.props.history.push("/smartcharts/reports");

        if (this.props?.smartChartReducer?.exportSmartChartDataResponse?.success === false) {
            this.showLongAlert(
                this.props?.smartChartReducer?.exportSmartChartDataResponse?.error ??
                    this.props?.smartChartReducer?.exportSmartChartDataResponse?.detail
            );
        } else {
            this.showLongAlert(
                "Report generation initiated and will be ready for download shortly. Please click the Refresh button to check for status."
            );
        }
        this.refreshExportedSmartChartList();
    };

    renderSmartChartViewPropertyModal = () => {
        const { showViewPropertyModal, selectedProperty, isLockLoading } = this.state;
        if (!showViewPropertyModal) return null;
        let smartChartPropertyByIdData = this.props.smartChartReducer.getSmartChartPropertyByIdResponse;
        const {
            match: {
                params: { section = "" }
            },
            isFavoriteView = false
        } = this.props;
        return (
            <Portal
                body={
                    <ViewPropertyModal
                        getSmartChartPropertyById={this.props.getSmartChartPropertyById}
                        smartChartPropertyByIdData={smartChartPropertyByIdData}
                        currentPropertyId={selectedProperty}
                        onCancel={() => this.setState({ showViewPropertyModal: false, selectedProperty: null })}
                        handleEditSmartChartProperty={this.handleEditSmartChartProperty}
                        currentTab={section}
                        showSmartChartDataEditModal={this.toggleSmartChartDataEditModal}
                        viewReports={this.toggleViewReportsModal}
                        lockOrUnlockReportTemplate={this.lockOrUnlockReportTemplate}
                        isLockLoading={isLockLoading}
                        isFavoriteView={isFavoriteView}
                        tableConfig={this.state?.RecommendationTableData?.config}
                        isGeoHierarchyReports={this.props?.isGeoHierarchyReports || false}
                    />
                }
                onCancel={() => this.setState({ showViewPropertyModal: false, selectedProperty: null })}
            />
        );
    };

    handleEditSmartChartProperty = (propertyData, fromModal = false) => {
        if (fromModal) {
            sessionStorage.setItem("selectedProperty", propertyData.id);
        }
        addToBreadCrumpData({
            key: "edit",
            name: "Edit Report Template",
            path: `/smartcharts/reporttemplates/edit/${propertyData.id}`
        });
        this.props.history.push(`/smartcharts/reporttemplates/edit/${propertyData.id}`, {
            property: propertyData
        });
    };

    handleExportSmartReport = async (params, refreshReports = false) => {
        let currentUser = localStorage.getItem("userId") || "";
        await this.props.exportSmartChartData({ ...params, user_id: currentUser });
        const {
            location: { pathname }
        } = this.props;
        if (this.props?.smartChartReducer?.exportSmartChartDataResponse?.success === false) {
            this.showLongAlert(
                this.props?.smartChartReducer?.exportSmartChartDataResponse?.error ??
                    this.props?.smartChartReducer?.exportSmartChartDataResponse?.detail
            );
        } else {
            this.showLongAlert(
                "Report generation initiated and will be ready for download shortly. Please click the Refresh button to check for status."
            );
        }
        if (pathname?.toLowerCase() === "/dashboard" && this.state.selectedTabForFavoriteView === "reporttemplates") {
            this.setState({ selectedTabForFavoriteView: "reports" });
        } else {
            this.props.history.push("/smartcharts/reports");
        }
        if (refreshReports) {
            this.refreshExportedSmartChartList();
        }
    };

    //temporary fix
    updateFiltersForMasterFilter = async filterValues => {
        await this.setState(prevState => {
            const nextFilters = {
                ...prevState.mFilters,
                ...filterValues,
                exportby_user_ids: []
            };
            return {
                mFilters: nextFilters
            };
        });
    };

    toggleViewReportsModal = (propertyId, skelView = false, isReportView) => {
        this.setState({
            showViewReportsModal: true,
            selectedProperty: propertyId,
            isSkeletonView: skelView,
            isViewReportModal: true,
            isReportViewModal: isReportView
        });
    };

    renderViewReportsModal = () => {
        const { showViewReportsModal, selectedProperty, mFilters, isSkeletonView } = this.state;
        if (!showViewReportsModal) return null;
        let clientId = mFilters?.client_ids?.[0] || "";
        return (
            <Portal
                body={
                    <ReportsByTemplateModal
                        currentPropertyId={selectedProperty}
                        clientId={clientId}
                        onCancel={() => this.setState({ showViewReportsModal: false, selectedProperty: null, isViewReportModal: false })}
                        isSkeletonView={isSkeletonView}
                        isModalView={this.props.isModalView}
                        isReportView={this.state?.isReportViewModal}
                    />
                }
                onCancel={() => this.setState({ showViewReportsModal: false, selectedProperty: null })}
            />
        );
    };

    lockOrUnlockReportTemplate = async template => {
        let userRole = localStorage.getItem("role");
        if (userRole !== "super_admin") {
            if (!template.password && template.is_locked) {
                this.showAlert("This template is locked by system admin. please contact admin to unlock it.");
            } else {
                this.setState({ showLockTemplateModal: true, selectedReportTemplate: template });
            }
        } else {
            this.lockUpdateConfirm(template);
        }
    };

    renderLockPasswordModal = () => {
        const { showLockTemplateModal, selectedReportTemplate, isLockLoading } = this.state;
        if (!showLockTemplateModal) return null;
        return (
            <Portal
                body={
                    <LockPasswordModal
                        onCancel={() => this.setState({ showLockTemplateModal: false })}
                        updateLockPassword={this.lockUpdateConfirm}
                        selectedReportTemplate={selectedReportTemplate}
                        isLockLoading={isLockLoading}
                    />
                }
                onCancel={() => this.setState({ showLockTemplateModal: false })}
            />
        );
    };

    lockUpdateConfirm = async templateParams => {
        let userRole = localStorage.getItem("role");
        let currentUser = localStorage.getItem("userId") || "";
        this.setState({ isLockLoading: true });

        let lockParams = {
            is_locked: !templateParams.is_locked,
            property_id: templateParams.id,
            user_id: currentUser
        };
        if (templateParams.password) {
            lockParams.password = templateParams.password;
        }
        await this.props.lockSmartChartTemplate(lockParams);
        if (this.props.smartChartReducer.lockSmartChartTemplateResponse.success === false && templateParams.is_locked && userRole !== "super_admin") {
            this.setState({ isLockLoading: false });
            this.showAlert("Wrong password !!!");
        } else {
            if (this.state.showViewPropertyModal) {
                this.props.getSmartChartPropertyById(templateParams.id);
            }
            this.setState({ showLockTemplateModal: false, isLockLoading: false });
        }
    };

    toggleSelectDownloadTypeModal = item => {
        this.setState({
            showSelectDownloadTypeModal: true,
            selectedReport: item
        });
    };

    renderSelectDownloadTypeModal = () => {
        const { showSelectDownloadTypeModal } = this.state;
        if (!showSelectDownloadTypeModal) return null;
        return (
            <Portal
                body={
                    <SelectDownloadTypeModal
                        onCancel={() => this.setState({ showSelectDownloadTypeModal: false })}
                        isSmartChart={true}
                        isBuildingAddition={false}
                        isWordExcel={false}
                        onOk={this.selectDownloadTypeConfirm}
                    />
                }
                onCancel={() => this.setState({ showSelectDownloadTypeModal: false, selectedReport: "" })}
            />
        );
    };

    selectDownloadTypeConfirm = (sortType, fileType) => {
        const { selectedReport } = this.state;
        this.setState({ showSelectDownloadTypeModal: false });
        this.handleDownloadItem(fileType === "pdf" ? selectedReport?.pdf_url : selectedReport?.doc_url);
    };

    addToFavorite = async id => {
        let currentUser = localStorage.getItem("userId") || "";
        await this.props.addSmartChartToFavorites({ user_id: currentUser, smart_export_id: id });
        this.refreshExportedSmartChartList();
    };

    handleSortData = async (key, value) => {
        await this.setState({
            sortParams: {
                ...this.state.sortParams,
                [key]: value
            }
        });
        await this.updateEntityParams();
        this.refreshExportedSmartChartList();
    };

    handleSelectViewType = async filter => {
        await this.setState({ filterKey: filter, mFilters: { ...this.state?.mFilters, exportby_user_ids: [] } });
        await this.updateEntityParams();
        this.refreshExportedSmartChartList();
    };

    toggleAssignUsersToFavoriteModal = (item = "") => {
        this.setState({
            showAssignUsersToFavoritesModal: !this.state.showAssignUsersToFavoritesModal,
            selectedReport: item
        });
    };

    renderAssignUsersToFavoriteModal = () => {
        const { showAssignUsersToFavoritesModal, mFilters, selectedReport } = this.state;
        if (!showAssignUsersToFavoritesModal) return null;
        let clientId = mFilters?.client_ids?.[0] || "";

        return (
            <Portal
                body={
                    <AssignUserToFavoriteModal
                        onCancel={() => this.toggleAssignUsersToFavoriteModal()}
                        clientId={clientId}
                        onAssignFavoriteToUsers={this.onAssignFavoriteToUsers}
                        selectedReportId={selectedReport}
                    />
                }
                onCancel={() => this.toggleAssignUsersToFavoriteModal()}
            />
        );
    };

    onAssignFavoriteToUsers = async params => {
        this.toggleAssignUsersToFavoriteModal();
        await this.props.assignFavoriteToUsers(params);
        this.showAlert("Assigned favorite report successfully");
        this.setState({ selectedReport: "" });
    };

    toggleCreateReportFromCoreReportModal = coreReport => {
        this.setState({ showCreateReportFromCoreReportModal: !this.state.showCreateReportFromCoreReportModal, selectedProperty: coreReport });
    };

    renderCreateReportFromCoreReportModal = () => {
        const { showCreateReportFromCoreReportModal, selectedProperty, mFilters } = this.state;
        const { isModalView } = this.props;
        if (!showCreateReportFromCoreReportModal) return null;
        return (
            <Portal
                body={
                    <CreateReportFromCoreReportsModal
                        onCancel={() => this.toggleCreateReportFromCoreReportModal()}
                        selectedCoreReport={selectedProperty}
                        mFilters={mFilters}
                        isModalView={isModalView}
                        changeTabsInFavModal={this.changeTabsInFavModal}
                    />
                }
                onCancel={() => this.toggleCreateReportFromCoreReportModal()}
            />
        );
    };

    changeTabsInFavModal = async key => {
        this.setState({ selectedTabForFavoriteView: key });
        await this.setState({ filterKey: "" });
        await this.refreshExportedSmartChartList();
    };
    handleDateFilterChange = async filter => {
        const { params } = this.state;
        await this.setState({
            params: {
                ...params,
                offset: 0,
                date_filter: { ...filter }
            },
            paginationParams: {
                ...this.state.paginationParams,
                currentPage: 0
            }
        });
        this.updateEntityParams();
        await this.refreshExportedSmartChartList();
    };

    render() {
        const {
            match: {
                params: { section = "", viewType = "" },
                path
            },
            getSmartChartMasterFilterDropDown,
            exportSmartChartData,
            saveSmartChartData,
            getSmartChartPropertyById,
            isModalView,
            isFavoriteView = false,
            isConnectedReport = false,
            reportTabBookmarks,
            isReportTabBookmarked,
            toggleReportTabBookmark
        } = this.props;
        const {
            showWildCardFilter,
            paginationParams,
            tableData,
            selectedRowId,
            mFilters,
            sortParams,
            filterKey,
            selectedTabForFavoriteView,
            params
        } = this.state;
        let projectsDropdownData = this.props.smartChartReducer.getprojectsInMasterDropdownData?.data || [];
        let exportSmartChartDataResponse = this.props.smartChartReducer.exportSmartChartDataResponse;
        let masterFilterList = this.props.smartChartReducer.masterFilterList;
        let saveSmartChartResponse = this.props.smartChartReducer.saveSmartChartDataResponse;
        let smartChartPropertyByIdData = this.props.smartChartReducer.getSmartChartPropertyByIdResponse;
        return (
            <LoadingOverlay active={this.state.isLoading} spinner={<Loader />} fadeSpeed={10}>
                <>
                    {(viewType === "edit" || section === "new") && !isModalView ? (
                        <CreateSmartChart
                            key={this.props.match.params.id || this.props.match.params.section || "new"}
                            getSmartChartMasterFilterDropDown={getSmartChartMasterFilterDropDown}
                            projectsDropdownData={projectsDropdownData}
                            exportSmartChartData={exportSmartChartData}
                            exportSmartChartDataResponse={exportSmartChartDataResponse}
                            masterFilterList={masterFilterList}
                            saveSmartChartData={saveSmartChartData}
                            saveSmartChartResponse={saveSmartChartResponse}
                            refreshTableData={this.refreshExportedSmartChartList}
                            viewReports={this.toggleViewReportsModal}
                            mFilters={mFilters}
                        />
                    ) : (
                        <SmartChartMain
                            showWildCardFilter={showWildCardFilter}
                            paginationParams={paginationParams}
                            tableData={tableData}
                            handleGlobalSearch={this.handleGlobalSearch}
                            globalSearchKey={this.state.params.search}
                            updateSelectedRow={this.updateSelectedRow}
                            selectedRowId={selectedRowId}
                            isColunmVisibleChanged={this.isColunmVisibleChanged}
                            toggleWildCardFilter={this.toggleWildCardFilter}
                            handlePerPageChange={this.handlePerPageChange}
                            handlePageClick={this.handlePageClick}
                            updateWildCardFilter={this.updateWildCardFilter}
                            wildCardFilter={this.state.params.filters}
                            handleHideColumn={this.handleHideColumn}
                            updateCommonFilter={this.updateCommonFilter}
                            commonFilter={this.state.params.list}
                            resetAllFilters={this.resetAllFilters}
                            resetAll={this.resetAll}
                            updateTableSortFilters={this.updateTableSortFilters}
                            resetSort={this.resetSort}
                            tableParams={this.state.params}
                            // showRestoreModal={this.showRestoreModal}
                            hasExport={checkPermission("forms", permissions.SMART_CHARTS, "export")}
                            showAddButton={checkPermission("forms", permissions.SMART_CHARTS, "create")}
                            hasEdit={checkPermission("forms", permissions.SMART_CHARTS, "edit")}
                            hasDelete={checkPermission("forms", permissions.SMART_CHARTS, "delete")}
                            hasOwnDelete={checkPermission("forms", permissions.SMART_CHART_OWN_REPORT, "delete")}
                            hasInfoPage={false}
                            entity={"exported_smart_charts"}
                            handleDownloadItem={this.handleDownloadItem}
                            refreshTableData={this.refreshExportedSmartChartList}
                            deleteSmartChartReport={this.deleteSmartChartReport}
                            regenerateSmartChart={this.regenerateSmartChart}
                            showSmartChartDataEditModal={this.toggleSmartChartDataEditModal}
                            showEditPage={this.toggleSmartChartDataEditModal}
                            getSmartChartMasterFilterDropDown={getSmartChartMasterFilterDropDown}
                            masterFilterList={masterFilterList}
                            mFilters={mFilters}
                            updateMfilterForSmartChartList={this.updateMfilterForSmartChartList}
                            handleClickTab={this.handleClickTab}
                            viewSmartChartProperty={this.viewSmartChartProperty}
                            handleEditSmartChartProperty={this.handleEditSmartChartProperty}
                            handleExportSmartReport={this.handleExportSmartReport}
                            updateFiltersForMasterFilter={this.updateFiltersForMasterFilter}
                            isModalView={isModalView}
                            viewReports={this.toggleViewReportsModal}
                            toggleSelectDownloadTypeModal={this.toggleSelectDownloadTypeModal}
                            addToFavorite={this.addToFavorite}
                            isFavoriteView={isFavoriteView}
                            handleSortData={this.handleSortData}
                            handleSelectViewType={this.handleSelectViewType}
                            sortParams={sortParams}
                            viewType={filterKey}
                            toggleAssignUsersToFavoriteModal={this.toggleAssignUsersToFavoriteModal}
                            toggleCreateReportFromCoreReportModal={this.toggleCreateReportFromCoreReportModal}
                            selectedTabForFavoriteView={selectedTabForFavoriteView}
                            path={path}
                            setUpdateCoreReport={this.state.setUpdateCoreReport}
                            setUpdateState={this.setUpdateState}
                            setShowDashboardSmartChartExport={() =>
                                this.setState({ showDashboardSmartChartExport: true, showSmartChartDataEditModal: true })
                            }
                            isReportView={this.props?.isReportView}
                            isBuildingReport={this.props?.isBuildingReport || false}
                            isConnectedReport={isConnectedReport}
                            handleDateFilterChange={this.handleDateFilterChange}
                            date_filter={params?.date_filter}
                            isGeoHierarchyReports={this.props?.isGeoHierarchyReports}
                            reportTabBookmarks={reportTabBookmarks}
                            isReportTabBookmarked={isReportTabBookmarked}
                            toggleReportTabBookmark={toggleReportTabBookmark}
                        />
                    )}
                    {this.renderConfirmationModal()}
                    {this.renderSmartChartDataEditModal()}
                    {this.renderSmartChartViewPropertyModal()}
                    {this.renderViewReportsModal()}
                    {this.renderLockPasswordModal()}
                    {this.renderSelectDownloadTypeModal()}
                    {this.renderAssignUsersToFavoriteModal()}
                    {this.renderCreateReportFromCoreReportModal()}
                </>
            </LoadingOverlay>
        );
    }
}

const mapStateToProps = state => {
    const { smartChartReducer, recommendationsReducer, dashboardReducer } = state;
    return { smartChartReducer, recommendationsReducer, dashboardReducer };
};

export default withRouter(
    connect(mapStateToProps, {
        ...actions
    })(Index)
);
